export default __webpack_public_path__ + "static/media/LeaderBoard_stand.d3a502a4.svg";